import { create } from 'zustand';

export interface AccessibleService {
  id: string;
  label: string;
  href: string;
  iconName?: string;
  labelType?: string[];
}

interface ServiceStore {
  accessibleServices: AccessibleService[];
  setAccessibleServices: (services: AccessibleService[]) => void;
}

export const useServiceStore = create<ServiceStore>((set) => ({
  accessibleServices: [],
  setAccessibleServices: (services) => set({ accessibleServices: services }),
}));
